module.exports = __webpack_public_path__ + "static/media/explore.f39d1e92.svg";